<template>
  <div class="container-fluid p-0">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
